import { Component, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DxPopupComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';


@Component({
  selector: 'app-messaggio',
  templateUrl: './messaggio.component.html',
  styleUrls: ['./messaggio.component.css']
})

export class MessaggioComponent implements OnInit {
  @ViewChild(DxPopupComponent, { static: false }) popup: DxPopupComponent;
  @Input() messaggio: any = '';
  @Input() titolo: string = '';
  @Input() ppVisible: boolean;
  @Input() showProgress: boolean = false;
  @Input() idMessaggio = -1;
  @Output() ppVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() tasti: string[] = []
  @Output() risposta: EventEmitter<any> = new EventEmitter<any>();
  @Input() Width: number;//|string|Function = -1;
  @Input() Height: number;//|string|Function = -1;
  @Input() progresso: number = 0
  @Input() progressoMax: number
  @Input() textProgressBar: string
  @Input() titleProgressBar: string = "Elaborazione in corso"

  okButtonOptions: any;
  siButtonOptions: any;
  noButtonOptions: any;
  confermaButtonOptions: any;
  cancelButtonOptions: any;

  _tasti: any[];
  _messaggi = ['Errore generico', "Impossibile completare l'operazione",];
  _testo: any;
  _pulsanti: ['Ok', 'Si', 'No', 'Conferma', 'Annulla',];
  _Height: number | string | Function;
  _Width: number | string | Function;
  _title: string;

  constructor(private _sanitizer: DomSanitizer, private route: Router) {

  }

  ngOnInit(): void {
  }

  aggiornaProgresso(progresso: number) {
    this.ppVisible = true
    this.progresso = progresso
  }

  showNotify(message: string, esitoElaborazione?: string, icon?: string) {
    notify({
      message: message,
      height: 45,
      width: 250,
      position: 'center center'
    }, esitoElaborazione, 4000);
  }
  apri() {
    const that = this;
    if (this.titolo != '') {
      this._title = this.titolo;
    } else {
      this._title = 'Attenzione!';
    }
    if (this.Width < 0) {
      this._Width = this.Width;

    } else {
      this._Width = "40%";
    }
    if (this.Height < 0) {
      this._Height = this.Height;

    } else {
      this._Height = "40%";
    }

    if (this.tasti.length > 0) {
      this.okButtonOptions = {
        text: this.tasti[0],
        visible: function () { return (this.tasti[0] != '') },
        onClick: function (e: any) {
          that.chiudi(0);
        }
      };
      this.siButtonOptions = {

        text: this.tasti[1],
        visible: function () { return (this.tasti[1] != '') },
        onClick: function (e: any) {
          that.chiudi(1);
        }
      };
      this.noButtonOptions = {

        text: this.tasti[2],
        visible: function () { return (this.tasti[2] != '') },
        onClick: function (e: any) {
          that.chiudi(2);
        }
      };
      this.confermaButtonOptions = {

        text: this.tasti[3],
        visible: function () { return (this.tasti[3] != '') },
        onClick: function (e: any) {
          that.chiudi(3);
        }
      };
      this.cancelButtonOptions = {
        text: this.tasti[4],
        visible: function () { return (this.tasti[4] != '') },
        onClick: function (e: any) {
          that.chiudi(4);
        }
      };
    }
    if (this.messaggio != '') { this._testo = this.messaggio }
    // { this._testo = this._messaggi[this.idMessaggio]}
    else { this._testo = this.messaggio };
    this._tasti = [this.okButtonOptions, this.siButtonOptions, this.noButtonOptions, this.confermaButtonOptions, this.cancelButtonOptions];
    if (this.idMessaggio > -1) {
      this._testo = this._messaggi[this.idMessaggio];
    } else {

      this._testo = this._sanitizer.bypassSecurityTrustHtml(this.messaggio);

    };

    if (this.tasti.length > 0) {
      this.tasti.forEach(elemento => {
        this.popup.toolbarItems.push({ widget: "dxButton", options: this._tasti[this.tasti.indexOf(elemento)], toolbar: "bottom", location: "center" });


      })


      this.popup.toolbarItems = this.popup.toolbarItems;

    }

  }

  chiudi(e: any) {
    this.risposta.emit(e);
    this.ppVisible = false;
    this.ppVisibleChange.emit(this.ppVisible);
    this.popup.toolbarItems = [];
    this.idMessaggio = -1;
    this._testo = '';

  }
  apriForm() {
    this.route.navigateByUrl('/form')
  }

  ngOnDestroy(): void {
    this.popup.toolbarItems = [];
    this._testo = '';
    this._tasti = [];
    this.progresso = 0;
    this.progressoMax = 0;
    this.ppVisible = false;
  }


}
export class MessaggioModule { }
